import React from "react";
import "../css/DrawerNav.css";
import Divider from "@material-ui/core/Divider";
import { Avatar } from "@material-ui/core";
import { useStateValue } from "../StateProvider";
import Signout from "./Signout";
import { Link } from "react-router-dom";

export default function DrawerNav() {
  const [{ user }] = useStateValue();
  return (
    <div className="drawerNav">
      <div className="drawerNav__top">
        <Avatar src={user.photoURL} />
        <h4>
          <Link to={`/profile/${user.displayName}`}>{user.displayName}</Link>
        </h4>
      </div>

      <Divider />
      <div className="drawerNav__body">
        <Signout />
      </div>
    </div>
  );
}
